import React from 'react'
import Contact from '../components/contact/Contact'

const ContactPage = () => {
  return (
    <div className="max-w-screen-xl mx-auto px-4 pt-24 pb-12">
      <Contact />
    </div>
  )
}

export default ContactPage
